import { render, staticRenderFns } from "./HackathonProfile.vue?vue&type=template&id=156a5416&"
import script from "./HackathonProfile.vue?vue&type=script&lang=js&"
export * from "./HackathonProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports